import { Injectable } from '@angular/core';
import { PCacheable } from 'ts-cacheable';
import { environment } from '../../environments/environment';
import { PostalAddressDto } from '../models/postal-address.dto';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class PostalAddressService {
  constructor(private readonly api: ApiService) {}

  @PCacheable()
  public async findDefault(): Promise<PostalAddressDto> {
    return await this.api.get<PostalAddressDto>(environment.api.postalAddress + '/default');
  }
}
